import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { SearchData, SearchResponseInterface } from 'app/models/search-response.model';
import { BehaviorSubject } from 'rxjs';
import { SearchParams } from './search-params';
import { UtilsService } from '../utils-service';

@Injectable({providedIn: 'root'})
export class SearchService {
    constructor(private api:ApiService, private utilsService: UtilsService) { }
    task: BehaviorSubject<SearchData>= new BehaviorSubject<SearchData>(null)

    get task$(){
        return this.task.asObservable()
    }

    searchTask(params:SearchParams){
            //let params={busqueda: text}
            const url=`/busqueda`
            return new Promise((resolve, reject)=>{
                this.api.GetMethod(url, params,  'Error al obtener resultados de la busqueda.')
                    .subscribe(async (response: SearchResponseInterface) => {

                        const archivosConURL = await Promise.all(
                        response.data.bienesCulturales.data.map(async archivo => {
                            let url = null;
                            // Validar que imagenFavorita sea un ID válido
                            if (archivo.imagenFavorita && archivo.imagenFavorita !== 0) {
                                url = await this.utilsService.getArchivosInternos(archivo.imagenFavorita)
                                    .catch(() => null);
                            }
                            return {
                                ...archivo,
                                blobURL: url
                            };
                        })

                        
                    );

                    const listadoBienes = {
                        total: response.data.bienesCulturales.total,
                        data: archivosConURL
                    };

                    const searchData={
                        solicitudes: response.data.solicitudes,
                        gestiones: response.data.gestiones,
                        bienesCulturales: listadoBienes,
                        coleccionistas: response.data.coleccionistas
                    }
                    
                        this.task.next(searchData)
                        resolve(response)  
                    }, error => {
                        reject(true)
                    })
            })
        }
}